import { TypedUser } from "interface/user.model";
import queryClient, { IQueryParams } from "queries";
import helpers from "helpers/index";
import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

/**
 *   Interface/model file auto generate for User_social_profile
 *   Interface for back-end
 *   Model for front-end.
 *   They are the same!
 */
export interface TypedUser_social_profile {
    id?: string;
    user_id?: string;
    social_name?: string;
    social_slug?: string;
    createdAt?: string;

    user?: TypedUser;
}


export enum ENUM_SOCIAL_NAME {
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    TIKTOK = 'tiktok',
    YOUTUBE = 'youtube',
    ZALO = 'zalo',
}


type IQuery = TypedUser_social_profile & IQueryParams;


/*
* List of all app
*/
export function useGetUserSocialProfile(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["user_social_profile/fetch_entity_list", object],
        queryFn: () => axios.get<TypedUser_social_profile[]>(`/user_social_profile${EndURL}`).then(response => response.data),
        retry: 1,
        enabled: Boolean(object?.user_id),
    });
}



export function useCreateUserSocialProfile() {
    return useMutation({
        mutationKey: ['user_social_profile/create_entity'],
        mutationFn: (entity: TypedUser_social_profile) => axios.post<any>(`/user_social_profile`, helpers.cleanEntity(entity)).then(res => res.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user_social_profile/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['phonelog/fetch_entities_list'] });
        }
    });
}


export function useDeleteUserSocialProfile() {
    return useMutation({
        mutationKey: ['user_social_profile/delete_entity'],
        mutationFn: (user_social_profile_id: string) => axios.delete<any>(`/user_social_profile/${user_social_profile_id}`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user_social_profile/fetch_entity_list'] });
        }

    });
}
